exports.default = {
  'ask_ai': '問問AI',
  'background_color': '背景顏色',
  'reset_to_default': '恢復默認',
  'black': '黑色',
  'gray': '灰色',
  'red': '紅色',
  'orange': '橙色',
  'yellow': '黃色',
  'green': '綠色',
  'blue': '藍色',
  'purple': '紫色',
  'transparent': '透明',
  'light_gray': '淺灰色',
  'light_red': '淺紅色',
  'light_orange': '淺橙色',
  'light_yellow': '淺黃色',
  'light_green': '淺綠色',
  'light_blue': '淺藍色',
  'light_purple': '淺紫色',
  'middle_gray': '中灰色',
  'middle_red': '中紅色',
  'middle_orange': '中橙色',
  'middle_yellow': '中黃色',
  'middle_green': '中綠色',
  'middle_blue': '中藍色',
  'middle_purple': '中紫色',
  'center_align': '居中',
  'font_color': '字體顏色',
  'border_color': '邊框顏色',
  'body_text': '正文',
  'heading_1': '一級標題',
  'heading_2': '二級標題',
  'heading_3': '三級標題',
  'heading_4': '四級標題',
  'heading_5': '五級標題',
  'heading_6': '六級標題',
  'heading_7': '七級標題',
  'heading_8': '八級標題',
  'heading_9': '九級標題',
  'numbered_list': '有序列表',
  'bullet_list': '無序列表',
  'task_list': '任務列表',
  'table': '表格',
  'image': '圖片',
  'video': '視頻',
  'audio': '音頻',
  'attachment': '附件',
  'emoji': '表情',
  'code_block': '代碼塊',
  'quote_block': '引用塊',
  'highlight_block': '高亮塊',
  'dividing_line': '分割線',
  'link': '鏈接',
  'alignment': '對齊',
  'color': '顏色',
  'cut': '剪切',
  'copy': '複製',
  'copy_success': '複製成功',
  'delete': '刪除',
  'space': '空格',
  'today_thoughts_enter': '今天有什麼想法？隨手輸入試試看，讓AI來幫你完成！',
  'continue_input_regenerate': '繼續輸入，重新生成',
  'thinking': '正在思考',
  'editing': '正在編輯',
  'abort_ai_editing': '你要終止Ai編輯？',
  'ai_editing_timeout': 'Ai編輯超時啦！你要保留還是放棄AI編輯？',
  'keep_or_abort_ai_editing': '你要保留還是放棄Ai編輯？',
  'ai_editing_error_end_waiting': 'AI編輯出錯啦！結束等待?',
  'keep': '保留',
  'abort': '終止',
  'end': '結束',
  'give_up': '放棄',
  'cancel': '取消',
  'executing': '執行中',
  'accept': '接受',
  'insert_below': '插入下方',
  'overwrite_original': '覆蓋原文',
  'try_again': '再試一次',
  'basics': '基礎',
  'others': '其他',
  'markdown_format_space': 'Markdown: # 空格',
  'markdown_format_h2_space': 'Markdown: ## 空格',
  'markdown_format_h3_space': 'Markdown: ### 空格',
  'markdown_format_h4_space': 'Markdown: #### 空格',
  'markdown_format_h5_space': 'Markdown: ##### 空格',
  'markdown_format_h6_space': 'Markdown: ###### 空格',
  'markdown_format_h7_space': 'Markdown: ####### 空格',
  'markdown_format_h8_space': 'Markdown: ######## 空格',
  'markdown_format_h9_space': 'Markdown: ######### 空格',
  'markdown_format_numbered_list': 'Markdown: 1.空格',
  'markdown_format_bullet_list': 'Markdown: - 空格',
  'markdown_format_check_list': 'Markdown: [] 空格',
  'markdown_format_code_block': 'Markdown: ``` 空格',
  'markdown_format_block_quote': 'Markdown: > 空格',
  'markdown_format_horizontal_rule': 'Markdown: ---',
  'upload_image_size_cannot_exceed_10m': '上傳圖片大小不能超過10M!',
  'upload_file_size_cannot_exceed_20m': '上傳文件大小不能超過20M!',
  'default_placeholder': '按空格喚醒AI助手，輸入/使用快捷功能',
  'insert_code_block': '插入代碼塊',
  'insert_a_code_block': '插入一個代碼塊',
  'block_quote': '引用塊',
  'insert_a_block_quote': '插入一個引用塊',
  'insert_dividing_line': '插入分割線',
  'insert_highlight_block': '插入高亮塊',
  'insert_image': '插入圖片',
  'insert_video': '插入視頻',
  'insert_file': '插入文件',
  'insert_table': '插入表格',
  'mermaid': '文本繪圖',
  'latex': '插入公式',
  'insert_link': '插入鏈接',
  'insert_a_link': '插入一個鏈接',
  'title': '標題',
  'used_for_subsection_and_group_titles': '用於小節和分組標題',
  'left_align': '左對齊',
  'right_align': '右對齊',
  'text_align': '文本對齊',
  'hello_what_can_i_do_for_you_today': '今天我能為你做些什麼？',
  'what_web_page_do_u_want': '今天想做個什麼網頁?',
  'create_website': '創建您的專屬網站',
  'talk_to_ai': '與 AI 助手對話，描述您的需求和想法，',
  'tailored_design': '我們將為您量身定制專業的網站設計。',
  'ask_them': '問問他們',
  'your_agents': '您的智能體',
  'chat': '聊天',
  'new_conversation': '新建對話',
  'history': '歷史記錄',
  'close': '關閉',
  'intelligent_assistant_pai': '智能助手pai',
  'quick_start': '快速開始',
  'upload_image': '上傳圖片',
  'upload_image_cannot_exceed_10m': '上傳圖片大小不能超過10M!',
  'upload_file_cannot_exceed_20m': '上傳文件大小不能超過20M!',
  'file_type_error': '文件類型錯誤!',
  'network_error_send_failed': '網絡錯誤,發送失敗。',
  'error_please_try_again_later': '報錯了，請稍後重試！',
  'answer_timeout_please_try_again_later': '回答超時請稍後重試！',
  'message_contains_inappropriate_content': '您發送的消息包含不合規內容，請檢查後重發！',
  'message_revoked_due_to_safety_compliance': '由於安全合規限制，該消息已撤回。',
  'continue_before_number': '繼續之前編號',
  'start_new_list': '開始新列表',
  'edit_number': '修改編號值',
  'new_number_value_is': '新編號值為',
  'continue_number': '繼續標題編號',
  'confirm': '確定',
  'afresh_number': '重新開始編號',
  'set_new_number': '設置標題編號',
  'from': '從',
  'start': '開始',
  'current_number_value_is': '當前編號的值為',
  'show_code_and_charts': '展示代碼和圖表',
  'only_show_code': '僅展示代碼',
  'only_show_charts': '僅展示圖表',
  'view': '視圖',
  'mermaid_error_message': '輸入代碼即可展示圖表',
  'original_size': '原始尺寸',
  'fit_to_screen': '適應屏幕',
  'zoom_in': '放大',
  'zoom_out': '縮小',
  'rotate_left': '向左旋轉',
  'rotate_right': '向右旋轉',
  'download_image': '下載'
}
